// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/pic-personas/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/pic-personas/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "PIC Persona" })
  return <Page />
}
